import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PaymentSummaryStep = ({ oop, formData, onNext, onBack }) => {
   return (
      <Card data-testid="payment-summary-step" className="w-full max-w-2xl mx-auto bg-white dark:bg-black">
         <CardHeader>
            <CardTitle className="text-center text-gray-900 dark:text-gray-100">Payment Summary</CardTitle>
         </CardHeader>
         <CardContent className="space-y-6">
            <div className="space-y-4">
               <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-100 dark:border-gray-700">
                  <h3 className="font-medium text-gray-900 dark:text-gray-100 mb-3">Order Details</h3>
                  <div className="space-y-2">
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Bill Number:</span>
                        <span className="text-gray-900 dark:text-gray-100">{oop?.billNo}</span>
                     </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Application Number:</span>
                        <span className="text-gray-900 dark:text-gray-100">{oop?.applicationId}</span>
                     </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Amount:</span>
                        <span className="text-gray-900 dark:text-gray-100">₱ {oop?.totalAmount?.toFixed(2)}</span>
                     </div>
                  </div>
               </div>

               <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-100 dark:border-gray-700">
                  <h3 className="font-medium text-gray-900 dark:text-gray-100 mb-3">Billing Information</h3>
                  <div className="space-y-2">
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Full Name:</span>
                        <span className="text-gray-900 dark:text-gray-100">{formData.fullName}</span>
                     </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Email:</span>
                        <span className="text-gray-900 dark:text-gray-100">{formData.email}</span>
                     </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Phone Number:</span>
                        <span className="text-gray-900 dark:text-gray-100">{formData.phoneNumber}</span>
                     </div>
                     <div className="flex justify-between text-sm">
                        <span className="text-gray-500 dark:text-gray-400">Address:</span>
                        <span className="text-gray-900 dark:text-gray-100">{formData.address}</span>
                     </div>
                  </div>
               </div>
            </div>

            <div className="flex justify-between gap-4">
               <Button
                  data-testid="back-button"
                  variant="outline"
                  onClick={onBack}
                  className="dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
               >
                  Back
               </Button>
               <Button
                  data-testid="proceed-payment-button"
                  onClick={onNext}
                  className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white
                     dark:from-green-500 dark:to-green-600 dark:hover:from-green-600 dark:hover:to-green-700"
               >
                  Proceed to Payment
               </Button>
            </div>
         </CardContent>
      </Card>
   );
};

export default PaymentSummaryStep;
